import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { StarterProvider } from '@/context/StarterContext';
import { AuthProvider, useAuthContext } from '@/context/AuthContext';
import { AppShell } from '@/components/layout/AppShell';
import { HomeView } from '@/components/dashboard/HomeView';
import { RecipePage } from '@/components/recipe/RecipePage';
import { SchedulePage } from '@/components/schedule/SchedulePage';
import { SettingsPage } from '@/components/settings/SettingsPage';
import { WizardPage } from '@/components/wizard/WizardPage';
import { PinEntry } from '@/components/auth/PinEntry';
import { checkAndMigrateSchema } from '@/lib/migration';

function AppContent() {
  const { auth } = useAuthContext();

  useEffect(() => {
    checkAndMigrateSchema();
  }, []);

  if (!auth.isAuthenticated) {
    return <PinEntry />;
  }

  return (
    <StarterProvider
      sessionToken={auth.sessionToken}
      apiBaseUrl="/api"
    >
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/" element={<HomeView />} />
          <Route path="/recipe" element={<RecipePage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/wizard" element={<WizardPage />} />
        </Route>
      </Routes>
    </StarterProvider>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}
